import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { SVGThemeProvider } from '../shared';

/**
 * Base SVG component
 *
 * @param props.svgColor defaults to "currentColor"; passed to child components via context
 */
var CheggSVG = /*#__PURE__*/forwardRef(function (props, ref) {
  var ariaHidden = props['aria-hidden'],
      ariaLabel = props['aria-label'],
      role = props.role,
      svgColor = props.svgColor,
      svgProps = _objectWithoutProperties(props, ["aria-hidden", "aria-label", "role", "svgColor"]);

  var label = typeof ariaLabel === 'string' ? ariaLabel.trim() : undefined; // Hide from accessibility tree if meaningless label or inappropriate role:

  var shouldBeHiddenFromScreenReaders = ariaHidden || !(Boolean(label) && role === 'img');
  return /*#__PURE__*/React.createElement(SVGThemeProvider, {
    theme: {
      svgColor: svgColor
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": shouldBeHiddenFromScreenReaders || undefined,
    "aria-label": shouldBeHiddenFromScreenReaders ? undefined : label,
    ref: ref,
    role: shouldBeHiddenFromScreenReaders ? 'presentation' : role
  }, svgProps)));
});
CheggSVG.displayName = 'CheggSVG';
CheggSVG.defaultProps = {
  preserveAspectRatio: 'xMidYMid meet',
  role: 'img',
  svgColor: 'currentColor',
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg'
};
export default CheggSVG;